// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mf-1";
export var rowFirst = "_mf-3";
export var rowLast = "_mf-5";
export var rowMiddle = "_mf-4";
export var ticketListScroll = "_mf-2";
export var ticketStack = "_mf-0";